import React from 'react'
import { arrayOf, string, func, bool } from 'prop-types'
import { Button, Grid } from '@cobalt/cobalt-react-components'
import '../../../assets/recovery-otp.css'
import {
  RECOVERY_OTP_CONFIG_TITLE,
  RECOVERY_OTP_CONFIG_MESSAGE,
  RECOVERY_OTP_CONFIG_BUTTON
} from '../../constants/ui.labels'
import {
  RecoveryOTPBox,
  ContentHeader,
  RecoveryOTPConfirm
} from '../../components'

const COPY_SUCCESS_FEEDBACK_DURATION = 2000

class RecoveryOTPConfiguration extends React.Component {
  state = { showConfirmation: false }

  showConfirmation = () => this.setState({ showConfirmation: true })

  onDismiss = () => this.setState({ showConfirmation: false })

  handlesClick = () =>
    this.props.requiresConfirm
      ? this.showConfirmation()
      : this.props.onConfirm()

  render() {
    const { onConfirm, confirmText, ...props } = this.props

    return (
      <Grid noPadding>
        <Grid.Group verticalGutters={Grid.Group.VERTICAL_GUTTERS}>
          <Grid.Column all="100" medium="100" small="100">
            <ContentHeader
              title={RECOVERY_OTP_CONFIG_TITLE}
              message={RECOVERY_OTP_CONFIG_MESSAGE}
            />
            {this.state.showConfirmation && (
              <RecoveryOTPConfirm
                onDismiss={this.onDismiss}
                onConfirm={onConfirm}
              />
            )}
            <RecoveryOTPBox
              {...props}
              copySuccessFeedbackDuration={COPY_SUCCESS_FEEDBACK_DURATION}
            />
          </Grid.Column>
        </Grid.Group>
        <Grid.Group verticalGutters={Grid.Group.VERTICAL_GUTTERS}>
          <Grid.Column all="100" medium="100" small="100">
            <Button primary fullWidth onClick={this.handlesClick}>
              {confirmText}
            </Button>
          </Grid.Column>
        </Grid.Group>
      </Grid>
    )
  }
}

RecoveryOTPConfiguration.propTypes = {
  otpList: arrayOf(string).isRequired,
  onConfirm: func.isRequired,
  requiresConfirm: bool,
  confirmText: string
}

RecoveryOTPConfiguration.defaultProps = {
  requiresConfirm: true,
  confirmText: RECOVERY_OTP_CONFIG_BUTTON
}

export default RecoveryOTPConfiguration
